export enum ImpositionMode {
  Automatic = 0,
  Custom = 1,
}

export enum CustomLayoutStatus {
  Empty = "empty",
  Editing = "editing",
  Ready = "ready",
  Stale = "stale",
}

export type CustomImpositionRotation = 0 | 90;

export type HorizontalAlign = "left" | "center" | "right";
export type VerticalAlign = "top" | "center" | "bottom";
export type CustomLayoutKind = "grid" | "mixed" | "custom";
export type PrintSheetMode = "full" | "custom";

export interface CustomImpositionRectangle {
  x: number;
  y: number;
  width: number;
  length: number;
}

export interface CustomImpositionDTO {
  Mode: ImpositionMode;
  PrintHouseMaterialSizeId: string;
  ProductType: string;
  Positions: CustomImpositionRectangle[];
  MarginX: number;
  MarginY: number;
  /** Backend cm. 0 = use purchased RAW (full material). */
  PrintWorkingWidth: number;
  /** Backend cm. 0 = use purchased RAW (full material). */
  PrintWorkingLength: number;
}

export interface CustomImpositionLayoutState {
  mode: ImpositionMode;
  printHouseMaterialSizeId: string | null;
  productType: string;
  positions: CustomImpositionRectangle[];
  /** PRINT SHEET canvas (not purchased RAW). */
  sheetWidthUm: number;
  sheetLengthUm: number;
  purchasedWidthUm: number;
  purchasedLengthUm: number;
  printSheetMode: PrintSheetMode;
  unitWidthUm: number;
  unitHeightUm: number;
  needsRecalculate: boolean;
  isStale: boolean;
  staleReason: "material" | "unit" | null;
  lastBackendError: string | null;
  draft: CustomImpositionDraft | null;
  marginXUm: number;
  marginYUm: number;
  bleedXUm: number;
  bleedYUm: number;
}

export interface CustomImpositionDraft {
  rows: number;
  columns: number;
  horizontalGapUm: number;
  verticalGapUm: number;
  rotation: CustomImpositionRotation;
  horizontalAlign: HorizontalAlign;
  verticalAlign: VerticalAlign;
  kind?: CustomLayoutKind;
}

export interface CustomImpositionSheetScale {
  scale: number;
  canvasWidth: number;
  canvasHeight: number;
}

export interface CustomImpositionLayoutIssue {
  type: "overlap" | "outOfBounds" | "invalidSize";
  index?: number;
}
